import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { KeycloakTokens, DecodedToken } from '../interfaces/auth.interface';
import { jwtDecode } from 'jwt-decode'; // Necesitarás instalar: npm install jwt-decode

interface GuestResponse {
  data: {
    token: string;
    uid: number;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getGuestAccess(): Observable<GuestResponse> {
    const headers = new HttpHeaders({
      'cli': 'Web',
      'appversion': '1.5',
      'serviceversion': '2',
      'latitude': '0',
      'longitude': '0'
    });

    return this.http.get<GuestResponse>(`${this.baseUrl}/users/guestaccess`, { headers });
  }

  saveWithOutAuthData(token: string, uid: number, gsid: number): void {
    localStorage.setItem('gstoken', token);
    localStorage.setItem('gsuid', uid.toString());
    localStorage.setItem('gsid', gsid.toString());
  }

  getAuthData(): { token: string | null, uid: string | null , gsid: string | null} {
    return {
      token: localStorage.getItem('gstoken'),
      uid: localStorage.getItem('gsuid'),
      gsid: localStorage.getItem('gsid'),
    };
  }

  clearAuthData(): void {
    localStorage.removeItem('gstoken');
    localStorage.removeItem('gsuid');
    localStorage.removeItem('gsid');
    localStorage.removeItem('gslogo');
  }

  handleAuthCallback(queryParams: string): Observable<any> {
    try {
      // Decodificar los tokens de la URL
      const tokenParam = decodeURIComponent(queryParams);
      const tokens: KeycloakTokens = JSON.parse(tokenParam);
      
      // Decodificar el token para obtener la información del usuario
      const decodedToken: DecodedToken = jwtDecode(tokens.access_token);

      // Guardar la información importante
      this.saveAuthData(tokens, decodedToken);

      return of({ success: true, user: decodedToken });
    } catch (error) {
      console.error('Error parsing auth response:', error);
      return of({ success: false, error });
    }
  }

  private saveAuthData(tokens: KeycloakTokens, userData: DecodedToken): void {
    
    // Guardar tokens
    localStorage.setItem('access_token', tokens.access_token);
    localStorage.setItem('refresh_token', tokens.refresh_token);
    localStorage.setItem('token_type', tokens.token_type);
    localStorage.setItem('gstoken', tokens.access_token);
    
    // Guardar información del usuario
    const userInfo = {
      id: userData.sub,
      name: userData.name,
      email: userData.email,
      phone: userData.phone_number,
      username: userData.preferred_username,
      givenName: userData.given_name,
      familyName: userData.family_name,
      emailVerified: userData.email_verified
    };
    
    localStorage.setItem('user_info', JSON.stringify(userInfo));
  }

  getGuestAccessAuthorize(): Observable<any> {
    const headers = new HttpHeaders({
      'cli': 'Web',
      'appversion': '1.5',
      'serviceversion': '2',
      'latitude': '0',
      'longitude': '0',
      'Authorization': `Bearer ${this.getAccessToken() || ''}`
    });

    const requestBody = {
      deviceidunique: '' // revisar que se debe mandar aqui, ya que esta es la url inteligente
    };

    return this.http.post<any>(`${this.baseUrl}/users/authorize`, requestBody, { headers });
  }

  getUserInfo(): any {
    const userInfo = localStorage.getItem('user_info');
    return userInfo ? JSON.parse(userInfo) : null;
  }

  getAccessToken(): string | null {
    return localStorage.getItem('access_token');
  }

  isAuthenticated(): boolean {
    return !!this.getAccessToken();
  }

  logout(): void {
    localStorage.removeItem('gscolor');
    localStorage.removeItem('gsemail');
    localStorage.removeItem('gsid');
    localStorage.removeItem('gslogo');
    localStorage.removeItem('gsname');
    localStorage.removeItem('gstoken');
    localStorage.removeItem('gsuid');
  }
}